import { render, staticRenderFns } from "./RegularMeeting copy.vue?vue&type=template&id=528fe667&scoped=true"
import script from "./RegularMeeting copy.vue?vue&type=script&lang=js"
export * from "./RegularMeeting copy.vue?vue&type=script&lang=js"
import style0 from "./RegularMeeting copy.vue?vue&type=style&index=0&id=528fe667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fe667",
  null
  
)

export default component.exports